<div class="card mb-4" data-identifier="access-areas-card" *ngIf="hasLoadError || areas.length > 0">
    <div class="card-header mm-card-header d-flex justify-content-between align-items-center">
        <span>Enhance Authorization</span>
        <span class="text-muted small fw-normal">Turned on or off for the whole enterprise</span>
    </div>
    <div class="card-body">
        <div *ngIf="hasLoadError" class="alert alert-danger d-flex justify-content-between align-items-center mb-0"
             data-identifier="access-areas-error">
            <span>Couldn't load the products for this enterprise.</span>
            <button type="button" class="btn btn-sm btn-outline-danger" [disabled]="isLoading" (click)="loadAreas()"
                    data-identifier="access-areas-retry">Retry</button>
        </div>
        <div *ngFor="let area of areas; let first = first"
             class="area-row"
             [class.border-top]="!first" [class.pt-3]="!first" [class.mt-3]="!first"
             [attr.data-identifier]="'access-area-' + area.name">
            <div class="fw-semibold">
                {{ area.displayName }}
                <span class="badge rounded-pill ms-1" [class.text-bg-success]="area.enabled" [class.text-bg-secondary]="!area.enabled"
                      [attr.data-identifier]="'access-area-' + area.name + '-status'">{{ area.enabled ? 'On' : 'Off' }}</span>
            </div>
            <div class="d-flex align-items-center">
                <span *ngIf="savingNames.has(area.name)" class="spinner-border spinner-border-sm text-secondary me-2" role="status"
                      aria-label="Saving"></span>
                <div class="form-check form-switch m-0">
                    <input class="form-check-input" type="checkbox" role="switch"
                           [checked]="area.enabled"
                           [disabled]="savingNames.has(area.name)"
                           [attr.aria-checked]="area.enabled"
                           [attr.aria-label]="area.displayName + ' for this enterprise'"
                           [attr.data-identifier]="'access-area-' + area.name + '-switch'"
                           (click)="onSwitchClick($event, area)">
                </div>
            </div>
        </div>
    </div>
</div>
